import React, { useState, useEffect } from 'react';
import axios from '../../../services/api';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const CreatePublicServiceModal = ({ isOpen, onClose, community, service, onSuccess }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    institutionName: '',
    jobTitle: '',
    contactName: '',
    isPublic: true
  });

  useEffect(() => {
    if (service) {
      setFormData({
        institutionName: service.institutionName,
        contactName: service.contactName,
        jobTitle: service?.jobTitle ?? '',
        isPublic: service.isPublic
      });
    } else {
      setFormData({
        institutionName: '',
        contactName: '',
        jobTitle: '',
        isPublic: true
      });
    }
  }, [service]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (service) {
        await axios.put(`/public-services/${service._id}`, { ...formData, communityId: community._id });
        toast.success(t('Public service updated successfully'));
      } else {
        await axios.post(`/public-services`, { ...formData, communityId: community._id });
        toast.success(t('Public service created successfully'));
      }
      setFormData({
        institutionName: '',
        contactName: '',
        jobTitle: '',
        isPublic: true
      });
      onSuccess();
      onClose();
    } catch (error) {
      toast.error(t('Public service save error'));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-end pr-[15%] pt-[7%] z-[60] app-text">
      <div className="bg-white w-[30vw] h-[55vh] rounded-lg shadow-xl relative overflow-hidden">
        <div className="bg-black text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
          <h2 className="text-lg font-semibold">{service ? t('Edit Public Service') : t('Create New Public Service')}</h2>
          <button onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 h-[calc(55vh-116px)] overflow-y-auto">
          <div className="space-y-4">
            <div>
              <label className="block mb-1">{t('Institution Name')}</label>
              <input
                type="text"
                value={formData.institutionName}
                onChange={(e) => setFormData({ ...formData, institutionName: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-1.5"
                required
              />
            </div>

            <div>
              <label className="block mb-1">{t('Job Title')}</label>
              <input
                type="text"
                value={formData.jobTitle}
                onChange={(e) => setFormData({ ...formData, jobTitle: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-1.5"
                required
              />
            </div>

            <div>
              <label className="block mb-1">{t('Contact Name')}</label>
              <input
                type="text"
                value={formData.contactName}
                onChange={(e) => setFormData({ ...formData, contactName: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-1.5"
                required
              />
            </div>

            <div>
              <div className="flex items-center gap-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    checked={formData.isPublic}
                    onChange={() => setFormData({ ...formData, isPublic: true })}
                    className="mr-2"
                  />
                  {t('Is Public')}
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    checked={!formData.isPublic}
                    onChange={() => setFormData({ ...formData, isPublic: false })}
                    className="mr-2"
                  />
                  {t('Not Public')}
                </label>
              </div>
            </div>
          </div>
        </form>

        {/* Fixed footer with buttons */}
        <div className="absolute bottom-0 left-0 right-0 px-4 py-3 border-t bg-white">
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-1.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
            >
              {t('Cancel')}
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              {service ? t('Update') : t('Save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePublicServiceModal;